import styled from 'styled-components';

export const DirectoryMenuContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
   height: 430px;
  overflow-x: hidden;
  overflow-y: auto;
  position:relative;

`;

export const Horiz = styled.div`
flex:1
`;
